import { createStructuredSelector } from 'reselect';
import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
    CfDiscountBanner,
    getCFDiscountBanner as getCFDiscountBannerAction,
    contentfulPage as contentfulPageSelector,
    getDiscountBannerContent,
} from 'ggApp/modules/contentful';
import { orderActive as orderActiveSelector } from 'ggApp/modules/order/selectors';

import { discountBannerFeatureFlagData as discountBannerFeatureFlagDataSelector } from 'ggApp/modules/featureFlag';
import ScreenWrap from './ScreenWrap';

const enhance = compose(
    connect(
        createStructuredSelector({
            order: orderActiveSelector,
            discountBanner: contentfulPageSelector(CfDiscountBanner),
            discountBannerFeatureFlagData: discountBannerFeatureFlagDataSelector,
        }),
        (dispatch) => ({
            getCFDiscountBanner: bindActionCreators(getCFDiscountBannerAction, dispatch),
        }),
    ),
    withProps(
        ({
            order: { store_code: storeCode },
            discountBanner = {},
            discountBannerFeatureFlagData,
        }) => {
            const flagValue =
                discountBannerFeatureFlagData && discountBannerFeatureFlagData.variantKey;
            const { feedbackBannerText, feedbackBannerCopyableText } = getDiscountBannerContent({
                flagValue,
                storeCode,
                discountBanner,
            });
            const feedbackBannerAvailable = flagValue && flagValue !== 'disabled';
            return {
                feedbackBannerAvailable,
                feedbackBannerText,
                feedbackBannerCopyableText,
            };
        },
    ),
);

export default enhance(ScreenWrap);
